{
  "zh-TW": {
    "texts": {
      "user": {
        "maintainer": "獲得維護者徽章以及最高等級的所有支持者福利。"
      },
      "index": "Your database for all information around Ships and Stations in Star Citizen.",
      "indexQuote": "“Strap into one of dozens of ships and embark on a life within the Star Citizen universe.<br>Unbound by profession or skill sets, you choose the path of your own life.”",
      "indexQuoteSource": "Author Unknown, Source:",
      "support": {
        "info": "不方便贊助？<a href=\"https://robertsspaceindustries.com/spectrum/community/SC/forum/57219/thread/fleetyards-net\" target=\"_blank\" rel=\"noopener\"><b>在 Spectrum 為我們按讚</b></a>，讓更多人發現 FleetYards。",
        "goal": "用於伺服器託管與資料服務等日常營運開支。",
        "code": "剛接觸星際公民？使用此邀請碼可獲得 5000 UEC 初始資金：",
        "thisMonth": "本月目標 %{goal}",
        "subline": "直接支持我們",
        "otherWays": "其他協助方式"
      },
      "appUpdate": {
        "withCodename": "FleetYards %{version}（%{codename}）已上線。重新載入即可切換。",
        "plain": "FleetYards %{version} 已上線。重新載入即可切換。"
      },
      "installApp": {
        "eventSignup": "將 FleetYards 安裝為應用程式，一鍵回到你的活動。",
        "iosIntro": "在 iPhone 和 iPad 上，可以透過分享選單安裝 FleetYards 這類應用程式：",
        "iosShare": "點一下瀏覽器工具列中的「分享」按鈕。",
        "iosAdd": "選擇「加入主畫面」，可能需要向下捲動才能找到。",
        "iosConfirm": "點一下「新增」。現在可以像其他應用程式一樣從主畫面開啟 FleetYards。"
      },
      "supportHint": {
        "hangarSync": "背景同步是我們託管帳單中最大的一項支出。FleetYards 仰賴捐款運作 — 任何支持都很重要。",
        "vehicleAdded": "FleetYards 免費、無廣告,完全靠捐款運作。如果它對你有幫助,一份小小的捐助就能維持它的運轉。",
        "fleetCreated": "艦隊是我們最耗資源的功能之一。FleetYards 因為捐款而保持免費和無廣告 — 歡迎你一起支持。",
        "loginMilestone": "你已經陪伴我們一段時間了 — 謝謝。FleetYards 仰賴捐款運作;如果你願意一起分攤費用,這裡有更多資訊。",
        "visitMilestone": "FleetYards 由社群資助 — 沒有廣告,沒有付費牆。如果你覺得它有用,一份小小的捐款就能發揮很大作用。"
      },
      "notFound": "You are currently venturing unknown space. In the event you are lost, the UEE highly recommends plotting a new destination back towards home-space.",
      "forbidden": "你的權限不包含此區域。如果某項功能仍在灰度發布中，等它對你開放後，可以在「設定 > 功能」中自行開啟。",
      "subscriptionRequired": "合約、活動、Logistics 和行程由支持 FleetYards 的人共同維持。該艦隊目前未在涵蓋範圍內 — 任何一位成員的捐助都會為整個艦隊開啟這四項功能。",
      "featureNotReady": "此功能尚未完成，即將推出。敬請期待！",
      "inviteInvalid": "此邀請連結無效。可能是輸入有誤、已過期，或已達到使用次數上限。請向邀請你的人索取新的連結。",
      "accessDenied": "您無權檢視此頁面。",
      "serverError": "伺服器目前遇到技術問題。請稍後再試。",
      "offline": "請求未能送達伺服器。你的裝置似乎已離線，或者無法連線到伺服器。請檢查網路連線後再試一次。",
      "invalidRequest": "伺服器無法處理此請求。請重新整理頁面後再試一次。",
      "invalidListRequest": "此篩選器或排序無效。請重置後重新顯示列表。",
      "compare": {
        "ships": {
          "info": "To start select at least two and not more than eight Ships you want to compare."
        }
      },
      "fleets": {
        "leaveInfo": "You can not leave a Fleet as an Admin.",
        "directory": "選擇被找到的已驗證艦隊。這裡的每支艦隊都已證明它管理著自己的 RSI 組織。"
      },
      "admin": {
        "destroyedFleets": {
          "purgedWarning": "還原已清除的艦隊只能盡力而為。角色、圖片、邀請連結與艦隊載具不會被還原。"
        },
        "models": {
          "viewsFolder": {
            "hint": "拖入一個資料夾，內含名為 top.png、side.png、front.png 與 angled.png 的檢視圖。彩繪版本加上 _colored 後綴，展開版本加上 extended_ 前綴，著陸版本加上 landed_ 前綴。flight_ 前綴或不加前綴都會歸入預設組。holo.gltf 也會一併處理，前綴規則相同。從後方與下方的檢視圖命名為 angled_rear.png、bottom.png、rear.png 與 starboard.png。不含內裝的 holo_lite.glb 使用相同的前綴；holo_textured.glb 只會歸入預設組。",
            "uploading": {
              "one": "正在上傳一個檔案…",
              "other": "正在上傳 %{count} 個檔案…"
            },
            "matched": {
              "one": "一個檔案已就緒 — 儲存即可套用。",
              "other": "%{count} 個檔案已就緒 — 儲存即可套用。"
            },
            "processing": {
              "one": "正在背景裁切一個視圖 — 完成後會在此更新。",
              "other": "正在背景裁切 %{count} 個視圖 — 完成後會在此更新。"
            },
            "processed": "所有視圖皆已處理完成。",
            "ignored": "已忽略：%{files}"
          }
        },
        "oauthApplications": {
          "rejectHint": "此原因會顯示給註冊此應用程式的人，請說明需要修改什麼。"
        }
      },
      "hangarTour": {
        "welcome": {
          "title": "歡迎來到你的機庫",
          "text": "你的機庫記錄著你擁有的每一艘艦船。這個簡短的導覽會告訴你各項功能在哪裡——你可以隨時透過 ? 按鈕重新開始。"
        },
        "add": {
          "title": "新增艦船",
          "text": "選擇一艘或多艘艦船以及各自的數量。在任何艦船的頁面或卡片上，書籤圖示也能將它加入你的機庫或願望清單。"
        },
        "sync": {
          "title": "從 RSI 同步",
          "text": "使用 FleetYards 瀏覽器擴充功能從 RSI 同步艦船、塗裝、裝飾品和裝備。每次同步後請查看結果。回購清單可在回購頁面單獨同步。"
        },
        "display": {
          "title": "顯示選項",
          "text": "在卡片和清單之間切換，設定預設排序，並選擇顯示哪些詳細資訊或欄位。在清單中可以同時選取多艘艦船一起修改。"
        },
        "groups": {
          "title": "群組",
          "text": "用 + 和鉛筆按鈕把艦船整理到你自己的群組中。點擊群組可依其篩選，滑鼠移上去可醒目標示其中的艦船。"
        },
        "vehicle": {
          "title": "每艘艦船的選單",
          "text": "在這裡編輯艦船：命名、選擇塗裝、設為旗艦、設定可見性、管理配裝，或移到願望清單。"
        },
        "wishlist": {
          "title": "願望清單",
          "text": "將想要但尚未擁有的艦船放入願望清單，取得後再移入機庫。"
        },
        "fleetchart": {
          "title": "艦隊圖",
          "text": "依比例並排展示你的艦船，並將圖表儲存為圖片。"
        },
        "stats": {
          "title": "統計",
          "text": "角色、製造商、尺寸以及你的花費，支援 CSV 匯出。"
        },
        "share": {
          "title": "分享你的機庫",
          "text": "分享公開機庫，並選擇顯示哪些艦船和群組。你也可以在機庫設定中建立、更換或停用秘密連結，即使機庫設為私人也能使用。任何持有該連結的人都能查看你的機庫及其統計資料。"
        },
        "menu": {
          "title": "更多",
          "text": "在此匯入或匯出機庫，或查看匯入歷史。在手機上，此選單還包含願望清單、艦隊圖、統計資料、質押物品和本導覽。"
        },
        "overview": {
          "title": "艦船的專屬頁面",
          "text": "點擊艦船標題開啟概覽，管理配置與可見性、撰寫船長日誌並上傳圖片。為擁有的艦船加入題詞銘牌，並儲存為圖片。每篇日誌都有獨立的可見性設定。"
        },
        "pledgeItems": {
          "title": "不只有艦船",
          "text": "從此選單開啟塗裝、裝飾品或裝備，瀏覽從 RSI 機庫同步的物品。回購項目單獨列出，可在其頁面同步。"
        },
        "reset": {
          "title": "遊戲清檔之後",
          "text": "在此重設遊戲內購買的艦船：將它們全部移入願望清單作為購物清單，或從機庫中移除。使用真實貨幣購買的艦船會保留。"
        },
        "inventories": {
          "title": "機庫庫存",
          "text": "追蹤各地點的物品、記錄存入和取出，並在機庫庫存中管理轉移。"
        },
        "exampleShip": {
          "title": "範例艦船",
          "text": "僅用於導覽，不會儲存到你的機庫。"
        }
      },
      "fleetTour": {
        "welcome": {
          "title": "你的艦隊已就緒",
          "text": "這個導覽會依序開啟設定艦隊的每個頁面，並指出其中的關鍵選項。隨時點擊艦隊頁面頂部的問號即可重新查看。"
        },
        "events": {
          "title": "活動與任務",
          "text": "規劃行動，讓成員報名飛船和座位，並把一切安排在艦隊行事曆中。"
        },
        "contracts": {
          "title": "合約",
          "text": "為成員發布任務，並在完成後向他們付款。"
        },
        "members": {
          "title": "邀請成員",
          "text": "透過 Fleetyards 使用者名稱邀請成員，或建立邀請連結分享到 Discord 或 RSI。加入申請也會出現在此頁面。"
        },
        "ships": {
          "title": "飛船與艦隊圖",
          "text": "成員分享的飛船共同組成艦隊的飛船。艦隊圖會將它們按比例並排展示。"
        },
        "membership": {
          "title": "你在艦隊中的飛船",
          "text": "每位成員決定艦隊能看到自己的哪些飛船：全部、某個機庫分組或不顯示。這裡是你自己的選擇。"
        },
        "rsi": {
          "title": "驗證你的 RSI 組織",
          "text": "輸入你組織的 SID 並進行驗證。驗證可以證明該組織屬於你，並保護你的艦隊 ID。"
        },
        "roles": {
          "title": "角色",
          "text": "每個角色決定其成員可以檢視和管理哪些內容。此頁面列出了每個角色的權限。"
        },
        "squadrons": {
          "title": "中隊與小組",
          "text": "開啟中隊功能，將成員劃分為各自擁有軍階的單位和小組。"
        },
        "discord": {
          "title": "連接 Discord",
          "text": "在你的 Discord 伺服器上安裝機器人，為每個軍階指派一個 Discord 角色，並將活動同步為預定活動。"
        },
        "settings": {
          "title": "公開艦隊頁面",
          "text": "決定艦隊頁面及其飛船是否公開；標誌、簡介和連結也在此頁面。"
        },
        "finish": {
          "title": "你的艦隊已設定完成",
          "text": "入門所需的就是這些。隨時點擊上方的問號即可重新查看此導覽。"
        }
      },
      "hangarPreview": {
        "sync": {
          "title": "從 RSI 同步",
          "text": "透過瀏覽器擴充功能或 hangarXPLOR 檔案匯入你的 pledge，無需逐艘新增艦船。"
        },
        "organise": {
          "title": "整理你的艦船",
          "text": "為艦船命名，設定塗裝、配裝和旗艦，並整理到你自己的群組中。"
        },
        "wishlist": {
          "title": "願望清單與特價",
          "text": "把想要的艦船放進願望清單，特價時收到通知。"
        },
        "fleetchart": {
          "title": "艦隊圖",
          "text": "依比例並排檢視你的艦船，並將圖表儲存為圖片。"
        },
        "stats": {
          "title": "機庫統計",
          "text": "角色、製造商、尺寸以及你的花費，一目了然。"
        },
        "share": {
          "title": "公開機庫",
          "text": "透過連結分享你的機庫——哪些艦船和群組可見由你決定。"
        }
      },
      "fleetPreview": {
        "members": {
          "title": "成員與角色",
          "text": "透過連結邀請組織成員，並用角色和中隊來管理他們。"
        },
        "ships": {
          "title": "艦隊艦船",
          "text": "所有成員的公開艦船匯集在一個可篩選、可搜尋的清單中。"
        },
        "fleetchart": {
          "title": "艦隊圖",
          "text": "依比例並排檢視整個艦隊，並儲存為圖片。"
        },
        "stats": {
          "title": "艦隊統計",
          "text": "依角色、尺寸和貨運容量分析你的艦隊。"
        },
        "allies": {
          "title": "盟友",
          "text": "與其他艦隊結盟，隨時掌握與你並肩飛行的夥伴。"
        },
        "discord": {
          "title": "Discord",
          "text": "在你的 Discord 伺服器發布公告和每週摘要，並讓成員透過身分組加入。"
        }
      },
      "impressum": {
        "visit": "訪問",
        "ytShipImages": "The Awesome Ship Images in the Hangar Fleetchart view are the work of <a href=\"https://twitter.com/WhyTeeZero\" target=\"_blank\" rel=\"noopener\">YT (Twitter: @WhyTeeZero)</a>.<br>Please visit his Spectrum post (see links below) and give him a upvote.",
        "erkul": "The ship metrics on Fleetyards are modelled on the formulas and readouts of Erkul's DPS Calculator. Thanks to the erkul.games team for sharing their work with the community.",
        "appSignal": "AppSignal provided a sponsored Open Source Account which helps to improve Fleetyards.net even further. Thanks :)",
        "copyright": "The contents and works created by the page operators, on these pages are subject to German copyright. Duplication, processing, distribution and any kind of exploitation outside the limits of Copyright require the written consent of the respective author or creator. Downloads and copies of this page are only for private, non-commercial use. Insofar as the content on This page was not created by the operator, are third-party copyrights respected. In particular, Third-party content as such. Please Contact us if you notice any sort of copyright infringement. We will remove any content immediately as we become aware of such violations.",
        "disclaimer": {
          "p1": "This is an unofficial Star Citizen fansite, not affiliated with the Cloud Imperium group of companies.",
          "p2": "All content on this site not authored by its host or users are property of their respective owners.",
          "p3": "Star Citizen®, Squadron 42®, Roberts Space Industries®, and Cloud Imperium® are registered trademarks of Cloud Imperium Rights LLC. All rights reserved."
        },
        "liabilityInternal": {
          "p1": "The content of out site has been compiled with meticulous care and to the best of our knowledge. However, We cannot assume any liability for the up-to-dateness, completeness or accuracy of any of the pages.",
          "p2": "Pursuant to section 7, para. 1 of the TMG (Telemediengesetz), We are liable for our own content on these pages in accordance with general laws. However, pursuant to sections 8 to 10 of the TMG, We are not under obligation to monitor external information provided or stored on our site. Once We have become aware of a specific infringement of the law, We will immediately remove the content in question. Any liability concerning this matter can only be assumed from the point in time at which the infringement becomes known to us."
        },
        "liabilityExternal": "Our site contains links to websites of third parties (“external links”). As the content of these sites is not under our control, We cannot assume any liability for such external content. In all cases, the provider of information of the linked sites is liable for the content and accuracy of the information provided. At the point in time when the links were placed, no infringements of the law were recognisable to us. As soon as an infringement of the law becomes known to us, We will immediately remove the link in question."
      },
      "privacy": {
        "text": "The use of our site is usually possible without providing any personal data. The collecting of personal data (eg email address) on our sites will be, as far as possible, on a voluntary basis. No personal data will be passed on to third parties without your explicit consent.<br>We point out that data transmission over the Internet (eg when communicating by email) can have security gaps. A complete protection of data against access by third parties is not possible.",
        "p1": "Below you can read about what Information we are using to provide you the services on %{app}. For most parts this only concerns registered Users but please read further to get a full overview.",
        "p2": {
          "headline": "我們使用哪些資訊?",
          "text": "Depending on if you are a registered User or only using %{app} as a Guest we use more or less Information from you."
        },
        "p3": {
          "headline": "作為訪客",
          "text": "作為 %{app} 的訪客，我們收集以下資料："
        },
        "analytics": {
          "headline": "使用分析",
          "basis": "%{app} 會統計頁面瀏覽次數，以了解網站的哪些部分實際被使用。這是基於我們經營與改善網站的正當利益，而非基於同意：資料僅由我們第一方收集，IP 位址在儲存前已匿名化，不會在您的裝置上放置 Cookie 或其他識別碼，也不會與任何廣告聯播網分享。",
          "retention": "個別的造訪與頁面瀏覽紀錄會在一個月後刪除。之後僅保留無法追溯到個人的彙總數據。刪除您的帳戶時，也會一併刪除為其記錄的造訪資料。",
          "objection": {
            "headline": "如何表示反對",
            "text": "您可以隨時反對使用分析，我們會停止記錄，而不只是將資料隱藏起來。",
            "user": "您在設定中的帳戶選項會套用到您登入的每一台裝置。",
            "guest": "沒有帳戶時，您可以在此表示反對。若您的瀏覽器傳送 Global Privacy Control 訊號，我們也會予以尊重。"
          }
        }
      },
      "settings": {
        "privacy": {
          "tracking": "匿名統計您造訪的頁面，不會在您的裝置上儲存任何資料。造訪紀錄會在一個月後刪除。",
          "onlineStatus": "只要你開著 FleetYards，你所屬艦隊的成員與你的好友就會在你的名字旁看到一個圓點。你的最近活動時間始終可見。",
          "supporterListed": "你的使用者名稱（絕不會是付款時使用的名字）是否顯示在支持者頁面上。隱藏的捐款仍計入目標；除非你選擇顯示，Patreon 贊助保持隱藏。"
        },
        "notifications": {
          "hint": "選擇每種事件要如何通知您。App 通知會收集在您的通知中心，郵件則寄到您帳戶的電子郵件地址。",
          "push": {
            "title": "推播通知",
            "intro": "即使 FleetYards 已關閉，也能在此裝置上收到通知。在下方的「推播」欄中選擇哪些通知以推播方式送達。",
            "unsupported": "此瀏覽器無法接收推播通知。在 iPhone 或 iPad 上，請先將 FleetYards 加入主畫面，再從那裡開啟。",
            "denied": "此瀏覽器已封鎖 FleetYards 的通知。請在瀏覽器的網站設定中允許通知，然後重新載入此頁面。",
            "on": "此裝置已開啟推播通知。",
            "off": "此裝置已關閉推播通知。",
            "device": "%{os} 上的 %{browser}",
            "unknownDevice": "未知瀏覽器",
            "thisDevice": "（此裝置）",
            "failed": "無法檢查此裝置的推播通知狀態。請重新載入頁面後再試一次。"
          }
        }
      },
      "signup": {
        "blocked": "You have been blocked from FleetYards.net.<br>This can have multiple Reasons.<br>For further Information please Contact us under info ( at ) fleetyards.net"
      },
      "roadmap": {
        "inactive": "This Item was removed from the Roadmap. This is its last location"
      },
      "twoFactor": {
        "backupCodes": "Save a copy of your Backup-Codes. They will only be visible this one time.",
        "disable": "要停用兩步驟驗證，只需輸入一個有效的權杖。",
        "enable": " To secure your FleetYards.net Account you can generate 2-Factor-Auth Tokens with Google Authenticator, 1Password or Authy."
      },
      "oauthAuthorize": {
        "requestingAccess": "%{clientName} 正在請求存取您的帳戶。",
        "scopesIntro": "此應用程式將能夠："
      },
      "buybackSync": {
        "info": "讀取你的 RSI 回購清單的每一頁，並用它取代 Fleetyards 上儲存的可回購承諾。你的機庫不會被變更。清單較長時需要幾分鐘。同步在背景進行：只要分頁保持開啟，你可以關閉此視窗並繼續使用 Fleetyards。",
        "unsupported": "你的 Fleetyards Sync 擴充功能還無法讀取可回購的承諾。請更新擴充功能以同步它們。",
        "detailsInfo": "首次同步還會讀取每個承諾的價格和保險，每個承諾一個 RSI 頁面，清單較長時可能需要十五分鐘左右。之後的同步只會讀取新的承諾。",
        "detailsUnsupported": "請更新你的 Fleetyards Sync 擴充功能，以便同時讀取價格和保險。",
        "detailsIncomplete": "部分價格無法從 RSI 讀取。下次同步時會再試一次。",
        "detailsBackground": "價格和保險現在在背景讀取。你可以關閉此視窗並繼續使用 Fleetyards；在完成之前請保持此分頁開啟。",
        "detailsRunning": "上次同步的價格和保險仍在讀取中。完成後才能開始新的同步。",
        "sessionHint": "同步會透過此工作階段讀取你的回購清單。",
        "pointReplace": "讀取你的 RSI 回購清單的每一頁，並用它取代這裡儲存的可回購承諾。",
        "pointUntouched": "你的機庫不會被變更。",
        "pointBackground": "在背景執行：你可以關閉此視窗，只需保持分頁開啟。",
        "finished": "你的可回購承諾與 RSI 清單一致。",
        "keepsRunning": "關閉此視窗後它仍會繼續執行。請保持分頁開啟，直到完成。"
      },
      "addToHangar": {
        "hangarHint": "你擁有這艘飛船。",
        "wishlistHint": "你想以後取得這艘飛船。"
      },
      "resetIngame": {
        "info": "資料重置會清除你在遊戲內購買的飛船。你可以將它們移至願望清單以便日後再次購買，或將它們從機庫中移除。不是在遊戲內購買的飛船不受影響。"
      },
      "syncExtension": {
        "gettingStarted": "To sync your RSI Hangar with Fleetyards you first need to install the Fleetyards Sync Extension for Firefox or Chromium based Browsers.",
        "alreadyRunning": "機庫同步已在進行中。請等待完成。",
        "missingUnmatchedGroup": "開始前，請選擇用於歸檔同步找不到的飛船的群組。",
        "signedOutTitle": "你尚未登入 RSI",
        "signedOut": "請在此瀏覽器中登入 RSI 網站，然後再檢查一次。",
        "sessionHint": "同步會透過此工作階段讀取你的承諾。",
        "finished": "你的機庫與 RSI 承諾一致，所有內容皆已比對。",
        "unmatched": "其餘內容皆已同步。下方列出的內容都沒有加入你的機庫。",
        "partialFailure": "部分變更可能已寫入你的機庫。重試是安全的：已同步的艦船會重新比對，不會重複加入。",
        "pointMatch": "依名稱和承諾 ID，找出你 RSI 機庫中已在這裡的艦船。",
        "pointAdd": "加入尚未在這裡的艦船。"
      },
      "setEmail": "要設定密碼、啟用雙重認證或接收郵件通知，您需要為帳戶添加電子郵件地址。您將收到一封確認郵件來驗證該地址。",
      "oauthApplications": {
        "pendingReview": "此應用程式已註冊，正在等待審核。在獲得核准前無法請求存取權限。",
        "rejected": "此應用程式已被拒絕，無法請求存取權限。依照原因所述修改後會重新進入審核佇列。",
        "returnedToReview": "修改重新導向 URI 或權限範圍會使已核准的應用程式重新進入審核。"
      },
      "payouts": {
        "accountFound": "%{username} 擁有 FleetYards 帳戶，將連結到此參與者。",
        "accountMissing": "沒有使用此使用者名稱的 FleetYards 帳戶。請檢查拼字，或在下方以名稱將其新增為訪客。",
        "guestHint": "用於沒有 FleetYards 帳戶的人，將顯示為訪客。",
        "deleteHint": "此行程尚無其他參與者，因此可以刪除。",
        "tourInvite": "%{username} 邀請你加入此行程。",
        "contractReady": "合約已完成。開啟分帳帳本，將報酬支付給承接人。",
        "contractNotReady": "此合約尚未開啟分帳帳本。",
        "expenseNeedsReview": "支出需經帳本管理者核准後才會計入。"
      },
      "fleet": {
        "contractCovers": "合約板為每種合約顯示的圖片。留空則使用下方的內建圖片。"
      },
      "vehicleLog": {
        "visibility": "公開條目會隨此艦船顯示在你的公開機庫中。",
        "visibilityHidden": "此艦船未列在你的公開機庫中，因此那裡不會顯示它的任何條目。",
        "empty": "記錄這艘艦船的經歷——在你將條目設為公開之前，只有你能看到它。",
        "publicEmpty": "這艘艦船的艦長還沒有分享任何日誌條目。",
        "noneForFilter": "沒有符合此篩選的條目。",
        "unavailable": "此日誌暫時無法使用。"
      },
      "vehiclePlaque": {
        "supporter": "其他所有樣式，都是獻給讓 Fleetyards 持續運作的支持者們的謝禮。",
        "keptStyle": "你的銘牌保留了支持者專屬的%{style}樣式。儲存後，它將切換為%{default}。",
        "credits": {
          "founders": "%{manufacturer}創辦人",
          "shipwrights": "%{manufacturer}造船師",
          "designers": "%{manufacturer}設計師",
          "directors": "%{manufacturer}總監"
        },
        "fromFleet": "來自艦隊",
        "classLine": "%{manufacturer} 出品的 %{model}",
        "commissioned": "建造於 %{shipyard}",
        "launched": "%{date} 下水",
        "launchedAt": "%{date} 於 %{port} 下水",
        "launchedFrom": "於 %{port} 下水",
        "captain": "艦長 %{name}",
        "captainOf": "艦長 %{name}，%{affiliation}",
        "year": "%{year}年%{month}",
        "empty": "還沒有獻詞。寫下一段，這艘船就有了自己的銘牌。",
        "visibility": "只要這艘船是公開的，任何人都能在你的公開機庫中看到銘牌。"
      },
      "vehicleOverview": {
        "noLoadouts": "還沒有配裝。從 Erkul 或 SPViewer 連結一個。",
        "locationPrivate": "只有你能看到你的艦船在哪裡。",
        "pickReplacesUpload": "從圖庫或塗裝中選擇圖片會取代你上傳的圖片。",
        "galleryEmpty": "這艘艦船還沒有圖庫圖片。"
      },
      "model": {
        "sectionEmpty": "%{model} 沒有任何%{section}。"
      },
      "hangarPledgeItems": {
        "addToInventory": "每項按其禮包所含數量加入。",
        "alreadyInInventory": {
          "other": "%{count} 項已在庫存中，保持不變。"
        },
        "noInventories": "你還沒有庫存。請先建立一個，再加入物品。"
      }
    }
  }
}
